import React from "react";
import { Card, Divider, Typography } from "antd";
import BinOutwardWash from "../../../components/Wash/BinOutward/BinOutWardWash";
import "../../../styles/global-ui.css";

const BinOutwardWashPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Bin Outward
          </Typography.Title>

          <Typography.Text className="page-subtitle">
            Manage and process bin outward operations for washing
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <BinOutwardWash userData={userData} />
      </Card>
    </div>
  );
};

export default BinOutwardWashPage;